import { components } from './components';

export const sharedEsCR = { components };
